import { Box, Stack, SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useContext } from 'react';
import { ResetFilterButtons } from '../../ResetFilterButtons';
import { SuppliersContext } from 'Context/SuppliersContext';
import { useSupplierContext } from 'Hooks/useSupplierContext';
import { useSuppliersDispatchType } from 'Hooks/useSuppliersDispatchType';
import { useLoader } from 'Hooks/useLoader';

export const General = () => {
  const { userLocation, initUserLocation } = useContext(SuppliersContext);
  const { filters, setFilters, dispatchSuppliers } = useSupplierContext();
  const dispatchType = useSuppliersDispatchType();

  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  const { loader, isLoading, setIsLoading } = useLoader(
    '25',
    { height: '40px' },
    25,
    false
  );

  const sortStyle: SxProps = {
    p: '6px 0 6px 16px',

    ':hover': {
      cursor: 'pointer',
      bgcolor: 'primary.shade_50_2',
    },
  };

  const sortHandler = (isAscending: boolean) => {
    const updatedFilters = {
      ...filters,
      orderByAscendingAlphabet: isAscending,
      orderByDescendingAlphabet: !isAscending,
    };
    setFilters(updatedFilters);
    dispatchSuppliers({
      type: dispatchType,
      payload: { value: updatedFilters },
    });
  };

  const locationHandler = () => {
    const updatedFilters = {
      ...filters,
      location: filters.location ? null : userLocation,
    };
    setFilters(updatedFilters);
    dispatchSuppliers({
      type: dispatchType,
      payload: { value: updatedFilters },
    });
  };

  const requestLocationHandler = async () => {
    setIsLoading(true);
    try {
      await initUserLocation();
    } finally {
      setIsLoading(false);
      locationHandler();
    }
  };

  const resetHandler = () => {
    const updatedFilters = {
      ...filters,
      orderByAscendingAlphabet: false,
      orderByDescendingAlphabet: false,
      location: null,
    };
    setFilters(updatedFilters);
    dispatchSuppliers({
      type: dispatchType,
      payload: { value: updatedFilters },
    });
  };

  return (
    <Stack
      sx={{
        pb: '60px',
      }}
    >
      {isLoading ? (
        <Box>{loader}</Box>
      ) : (
        <Typography
          tabIndex={0}
          variant='body6'
          sx={{
            ...sortStyle,
            bgcolor: filters.location ? 'primary.shade_100' : undefined,
            fontWeight: filters.location ? '600 !important' : undefined,
          }}
          onClick={() =>
            userLocation ? locationHandler() : requestLocationHandler()
          }
        >
          {dictionary.closestLocation}
          {!userLocation && (
            <Box
              component='span'
              sx={{
                width: 'fit-content',
                ml: '5px',
                color: '#E12D2D',
              }}
            >
              {dictionary.notActive}
            </Box>
          )}
        </Typography>
      )}

      <Typography
        tabIndex={0}
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor: filters.orderByAscendingAlphabet
            ? 'primary.shade_100'
            : undefined,
          fontWeight: filters.orderByAscendingAlphabet
            ? '600 !important'
            : undefined,
        }}
        onClick={() => sortHandler(true)}
      >
        {dictionary.orderByAscendingAlphabet}
      </Typography>
      <Typography
        tabIndex={0}
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor: filters.orderByDescendingAlphabet
            ? 'primary.shade_100'
            : undefined,
          fontWeight: filters.orderByDescendingAlphabet
            ? '600 !important'
            : undefined,
        }}
        onClick={() => sortHandler(false)}
      >
        {dictionary.orderByDescendingAlphabet}
      </Typography>
      <ResetFilterButtons
        resetCallback={() => resetHandler()}
        sx={{
          justifyContent: 'flex-start',
        }}
      />
    </Stack>
  );
};
